module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"actual":"実績","hours":"時間","minutes":"分","within":"以内","ago":"前","now":"現在"},"en":{"actual":"Actual","hours":"hours","minutes":"minutes","within":" ","ago":" ago","now":"now"}}')
  delete Component.options._Ctor
}
